export default "<ngx-alerts></ngx-alerts>\n<ng-http-loader></ng-http-loader>\n<iframe width=\"100%\" height=\"600\"  [src]=\"urlSafe\"></iframe>\n";